import { RouteRecordRaw } from 'vue-router'

const productInsightsRoutes: RouteRecordRaw = {
  path: 'productAnalytics',
  name: 'productAnalytics',
  component: () =>
    import('@/views/ProductInsignts/Wrapper/ProductInsightsWrapper.vue'),
  meta: {
    title: 'Product Analytics'
  },
  beforeEnter: async (to, from, next) => {
    next()
  }
}

export default productInsightsRoutes
